export enum HelpPageLocations {
    DASHBOARD,
    LISTINGS,
    LISTING_PAGE,
    USERS,
    DEFAULT,
}

export const helpPageLocationsEnumMap: { [key: number]: string } = {
    [HelpPageLocations.DASHBOARD]: '/bundle/SCHOnline_Help/page/Dashboard.1.html',
    [HelpPageLocations.LISTINGS]: '/bundle/SCHOnline_Help/page/Listings_Page.html',
    [HelpPageLocations.LISTING_PAGE]: '/bundle/SCHOnline_Help/page/Listing_Details_Sections_and_Attribute_Options.html',
    [HelpPageLocations.USERS]: '/bundle/SCHOnline_Help/page/Users_Page.html',
    [HelpPageLocations.DEFAULT]: '/bundle/SCHOnline_Help/page/Overview_of_the_SCH.html',
};

export const helpPageLocationsUrlMap: { [key in HelpPageLocations]: string } = {
    [HelpPageLocations.DASHBOARD]: '/dashboard',
    [HelpPageLocations.LISTINGS]: '/listings',
    [HelpPageLocations.LISTING_PAGE]: '/listings/details',
    [HelpPageLocations.USERS]: '/users',
    [HelpPageLocations.DEFAULT]: '',
};
